import { render } from "./EmailModal.vue?vue&type=template&id=28c5e132&scoped=true"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"

import "./EmailModal.vue?vue&type=style&index=0&id=28c5e132&lang=scss&scoped=true"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c5e132"]])

export default __exports__